(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_video-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    initSwiper();
});

document.addEventListener("shopify:section:load", function(event) {
    if (event.target.querySelector(".reelSwiper")) {
        initSwiper();
    }
});

function initSwiper() {
    const swiper = new Swiper(".reelSwiper", {
        slidesPerView: 4,
        spaceBetween: 15,
        breakpoints: {
            0: { slidesPerView: 1.5, spaceBetween: 15 },
            768: { slidesPerView: 4, spaceBetween: 15 }
        }
    });

    initVideoControls(swiper);
}

function initVideoControls(swiper) {
    const videoWrappers = document.querySelectorAll('.reelVideoWrapper');

    videoWrappers.forEach(wrapper => {
        const video = wrapper.querySelector('[data-video]');
        const playBtn = wrapper.querySelector('[data-play-btn]');
        
        if (!video || !playBtn) return;

        playBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleVideo(video, playBtn);
        });

        wrapper.addEventListener('click', (e) => {
            if (e.target === playBtn || playBtn.contains(e.target)) return;
            if (!video.paused) toggleVideo(video, playBtn);
        });

        video.addEventListener('ended', () => {
            playBtn.classList.remove('hidden');
        });
    });

    function toggleVideo(video, playBtn) {
        if (video.paused) {
            document.querySelectorAll('[data-video]').forEach(v => {
                if (v !== video && !v.paused) {
                    v.pause();
                    v.closest('.reelVideoWrapper').querySelector('[data-play-btn]').classList.remove('hidden');
                }
            });
            video.play().then(() => playBtn.classList.add('hidden'));
        } else {
            video.pause();
            playBtn.classList.remove('hidden');
        }
    }

    swiper.on('slideChange', () => {
        document.querySelectorAll('[data-video]').forEach(video => {
            if (!video.paused) {
                video.pause();
                video.closest('.reelVideoWrapper').querySelector('[data-play-btn]').classList.remove('hidden');
            }
        });
    });
}

  } catch(e) { console.error(e); }
})();
})();
